import Icon from "components/shared/Icon";
import Title from "components/shared/Title";
import { Context } from "Context";
import { useContext } from "react";
import { HEADING_TYPES } from "./Heading";
import Link from "./Link";

const mainClass = "help-link-group";
const Topics = {
	help: "help",
	faq: "faq",
};
const LinkGroup = ({
	id = "",
	icon = "",
	title = "",
	subTitle = "",
	link = null,
	parentClass = null,
}) => {
	const { group } = useContext(Context);
	return (
		<Link
			{...link}
			id={id}
			className={`${mainClass} ${mainClass}--${group}${
				parentClass ? ` ${parentClass}` : ""
			}`}
		>
			{icon && <Icon icon={icon} className={`${mainClass}__icon`} />}
			{group === Topics.help && (
				<Title
					headingType={HEADING_TYPES.p}
					title={title}
					subTitle={subTitle}
					modifier={group}
				/>
			)}
			{group === Topics.faq && (
				<div dangerouslySetInnerHTML={{ __html: title }} />
			)}
			<Icon icon="next" className={`${mainClass}__icon--next`} />
		</Link>
	);
};

export default LinkGroup;
